if (!customElements.get('component-hero')) {
  class ComponentHero extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.data = this.querySelector('[data-text-entries]');
      this.rotatingText = this.querySelector('[data-rotating-text]');
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.init();
      this.initVideo();
      this.initBanners();
    }

    disconnectedCallback() {
      this.stopBanners();

      if (this.bannerObserver) this.bannerObserver.disconnect();
      if (this.videoObserver) this.videoObserver.disconnect();

      if (this.breakpoint && this.onBreakpointChange) {
        this.breakpoint.removeEventListener('change', this.onBreakpointChange);
      }

      if (this.onVisibilityChange) {
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
      }
    }

    init() {
      if (!this.rotatingText || !this.data) return;

      try {
        this.phrases = JSON.parse(this.data.textContent);

        carousel(this.phrases, this.rotatingText);

        this.classList.add('is-initialized');
      } catch (error) {
        console.error(error.message);
      }
    }

    initVideo() {
      if (!this.querySelector('[data-hero-media]')) return;

      this.videoSlot = this.querySelector('[data-hero-video-slot]');

      if (this.videoSlot) {
        this.breakpoint = window.matchMedia('(min-width: 990px)');
        this.onBreakpointChange = () => this.mountVideo();

        this.breakpoint.addEventListener('change', this.onBreakpointChange);
        this.mountVideo();
      } else {
        this.observeVideo();
      }
    }

    mountVideo() {
      const variant = this.breakpoint.matches ? 'desktop' : 'mobile';

      if (this.mountedVideo === variant) return;

      const template = this.querySelector(`[data-hero-video-template="${variant}"]`);

      if (!template) return;

      this.videoSlot.replaceChildren(template.content.cloneNode(true));
      this.mountedVideo = variant;

      this.observeVideo();
    }

    observeVideo() {
      const video = this.querySelector('.hero__video');

      if (!video) return;

      if (this.videoObserver) this.videoObserver.disconnect();

      if (this.reduceMotion && video.autoplay) {
        video.autoplay = false;
        video.removeAttribute('autoplay');
        video.pause();

        return;
      }

      if (!video.autoplay) return;

      this.videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const playing = video.play();

            if (playing) playing.catch(() => {});
          } else {
            video.pause();
          }
        });
      });

      this.videoObserver.observe(video);
    }

    initBanners() {
      this.banners = this.querySelectorAll('[data-hero-banner]');

      if (this.banners.length < 2 || this.reduceMotion) return;

      this.interval = parseInt(this.dataset.bannerInterval, 10) || 3000;
      this.activeBanner = 0;
      this.inView = false;

      this.bannerObserver = new IntersectionObserver((entries) => {
        this.inView = entries[0].isIntersecting;

        if (this.inView) {
          this.startBanners();
        } else {
          this.stopBanners();
        }
      });

      this.bannerObserver.observe(this);

      this.onVisibilityChange = () => {
        if (document.hidden) {
          this.stopBanners();
        } else {
          this.startBanners();
        }
      };

      document.addEventListener('visibilitychange', this.onVisibilityChange);
    }

    startBanners() {
      if (this.timer || !this.inView || document.hidden) return;

      this.timer = setInterval(() => this.nextBanner(), this.interval);
    }

    stopBanners() {
      if (!this.timer) return;

      clearInterval(this.timer);
      this.timer = null;
    }

    nextBanner() {
      this.banners[this.activeBanner].classList.remove('is-active');

      this.activeBanner = (this.activeBanner + 1) % this.banners.length;

      this.banners[this.activeBanner].classList.add('is-active');
    }
  }

  customElements.define('component-hero', ComponentHero);
}
